// extracted by mini-css-extract-plugin
export default {"onTop":"onTop__1HQsv"};